import { YandexMetrica } from 'utils/YandexMetrica';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

window.dataLayer = window.dataLayer || [];

/**
 * Parameters for event tracking are as follows:
 * @url https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param {string} type – 'event'
 * @param {string} eventName – Event name
 * @param {Object} params – Event parameters
 * @param {string} [params.event_category] – The category to which the event belongs (e.g. engagement)
 * @param {string} params.event_action – The type of interaction (e.g. login). The event_name is the default value for event_action
 * @param {string} [params.event_label] – The additional information for the event (e.g. article (the selected content type))
 * @param {string} [params.value] – A non-negative numeric value associated with the event (e.g. 42)
 */
export default function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer && window.dataLayer.push(arguments);
}

type Params = {
    event_category: string;
    event_action: string;
    event_label?: string;
    URL_ev?: string;
};

type Event = {
    eventName?: string;
    category?: string;
    action: string;
    label?: string;
};
export const metrics = {
    send({
        category = 'mcsplatform',
        action,
        label,
        eventName = 'MainEvent',
    }: Event) {
        const params: Params = {
            event_category: category,
            event_action: action,
            event_label: label || BoundCurrentUserSelectors.getPid(),
            URL_ev: window.location.href,
        };

        // @ts-ignore
        gtag('event', eventName, params);
        YandexMetrica.reachGoal(action);
    },
};
